import React, { Component } from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import { Button } from "cxa-components";
import {
  removeActivity,
  resendActivityDetails,
  MY_ACTIVITIES_RESEND_REQUEST,
} from "actions/shopActivitiesActions";
import { FormattedCustomDate } from "components/common/FormattedComponents";
import moment from "moment";
import { intlShape, injectIntl } from "react-intl";
import messages from "components/messagesDescription";
import { showToast } from "actions/toastActions";
import CancelDialog from "./CancelDialog";
import { compose, withHandlers, withState } from "recompose";

const mapStateToProps = ({
  shopActivity: { activity: processingActivity, fetching: processing, error, resendStatus },
}) => ({
  processingActivity,
  processing,
  error,
  resendStatus,
});

const mapDispatchToProps = {
  removeActivity,
  resendActivityDetails,
  showToast,
};

const enhanceActivity = compose(
  injectIntl,
  connect(
    mapStateToProps,
    mapDispatchToProps
  ),
  withState("isDeleteItemModalOpen", "toggleDeleteItemModal", false),
  withHandlers({
    openDeleteItemModal: props => () => props.toggleDeleteItemModal(true),
    closeDeleteItemModal: props => () => props.toggleDeleteItemModal(false),
  })
);

class Activity extends Component {
  removeActivity = code => {
    const { activity } = this.props;

    this.props.removeActivity(activity.activityId, code);
  };

  resendVoucher = code => {
    const { activity } = this.props;

    this.props.resendActivityDetails(activity.activityId, code);
  };

  render() {
    const {
      activity,
      showStatus,
      showCount,
      showProvider,
      showVoucherActions,
      intl,
      resendStatus,
      isDeleteItemModalOpen,
      openDeleteItemModal,
      closeDeleteItemModal,
    } = this.props;
    const signupId = activity.signUpId ? activity.signUpId : 0;

    const startDate = moment(activity.eventStartDate);
    const endDate = moment(activity.eventEndDate);
    const signUpEndDate = moment(activity.signUpEndDate);
    const dateDiff = endDate.diff(startDate, "days");
    const location =
      activity.locationNames && activity.locationNames.length > 0
        ? activity.locationNames.join(", ")
        : activity.locationNames;

    // Set Activity Status
    let status = activity.status || activity.activityStatus;
    switch (status) {
      case "Open":
      case "Pending":
      case "Reversed":
        status = "e-Voucher Issued";
        break;
      case "Completed":
        status = "Redeemed";
        break;
    }

    const statusGroup = activity.statusGroup;

    let canCancel = activity.signUpCode && activity.signUpCode.length > 0;

    if (canCancel) {
      canCancel = signUpEndDate.diff(new Date(), "minutes") > 0 && statusGroup === "Outstanding";
    }

    const ActivityLink = props => (
      <Link
        to={`/wellness/activities/${activity.activityId}/${signupId}`}
        aria-label={`View details of ${activity.activityName}`}
        {...props}
      />
    );

    return (
      <article className="grid__item grid__item--three apl-showcase__item">
        {isDeleteItemModalOpen && (
          <CancelDialog
            isOpen
            activityName={activity.activityName}
            closeDeleteItemModal={closeDeleteItemModal}
            removeActivity={this.removeActivity}
            activityId={signupId}
            signUpCode={activity.signUpCode}
          />
        )}
        <figure className="apl-figure--overlayed">
          <ActivityLink>
            <img src={activity.imageUri || activity.image} alt="" />
          </ActivityLink>
          {showCount && activity.hasLimitedSignUps && (
            <figcaption>
              {activity.signUpsAvailable} {intl.formatMessage(messages.daysLeftDescription)}
            </figcaption>
          )}
        </figure>

        <header>
          <h4>{activity.activityName}</h4>
        </header>
        <section>
          <p>
            <FormattedCustomDate value={activity.eventStartDate} />{" "}
            {dateDiff > 0 && <span> - {intl.formatMessage(activity.eventEndDate)}</span>}
            {startDate.format("HH:mm")}
          </p>
          {location && <p>{location}</p>}

          {showProvider && <p>{activity.providerName}</p>}

          {showStatus && <p>{intl.formatMessage({ id: status, defaultMessage: status })}</p>}
        </section>
        <footer>
          <p>
            <ActivityLink className="button">
              {intl.formatMessage(messages.viewDetailsDescription)}
            </ActivityLink>
            {canCancel && showVoucherActions && (
              <Button
                type="button"
                secondary
                disabled={resendStatus === MY_ACTIVITIES_RESEND_REQUEST}
                onClick={() => this.resendVoucher(activity.signUpCode)}
              >
                {intl.formatMessage(messages.resendVoucherDescription)}
              </Button>
            )}
            {canCancel && showVoucherActions && (
              <Button type="button" tertiary onClick={openDeleteItemModal}>
                {intl.formatMessage(messages.cancelSignUpDescription)}
              </Button>
            )}
          </p>
        </footer>
      </article>
    );
  }
}

Activity.propTypes = {
  activity: PropTypes.object.isRequired,
  removeActivity: PropTypes.func,
  resendActivityDetails: PropTypes.func,
  showStatus: PropTypes.bool,
  showCount: PropTypes.bool,
  showProvider: PropTypes.bool,
  showDownload: PropTypes.bool,
  showVoucherActions: PropTypes.bool,
  intl: intlShape.isRequired,
  processing: PropTypes.bool,
  resendStatus: PropTypes.string,
  isDeleteItemModalOpen: PropTypes.bool,
  closeDeleteItemModal: PropTypes.func,
  openDeleteItemModal: PropTypes.func,
};

export default enhanceActivity(Activity);



// WEBPACK FOOTER //
// ./components/wellness/activities/activity.jsx